<template>
  <div class="role-view">
    <div class="sidebar">
      <el-input
        v-model="keyword" placeholder="请输入关键字搜索"
        @keyup.enter.native="searchRoles" class="search-box"
      >
        <i slot="suffix" class="mdg-icon ico_search_grayx" @click="searchRoles"></i>
      </el-input>
      <el-button @click="changeToCreateMode" plain class="create-btn width-100 my-15">
        <i class="mdg-icon ico_creatx text-primary vcenter"></i>
        <span class="vcenter">新增职位</span>
      </el-button>
      <div id="role-list" v-if="shownRoles.length > 0">
        <div
          v-for="role in shownRoles" :key="role.id" class="role-item"
          :class="{selected: selectedRole.id === role.id}"
          @click="changeSelectedRole(role)"
        >
          <i class="mdg-icon ico_juesex vcenter"></i>
          <span class="vcenter">{{ role.name }}</span>
        </div>
      </div>
      <div v-else class="text-center text-placeholder my-10">暂无数据</div>
    </div>
    <div class="main-content">
      <div v-if="mode === 'view' && roles.length > 0" class="card">
        <div class="card-header">
          <div>
            <i class="mdg-icon ico_department-staffx title-icon"></i>
            <span class="title">
              {{ selectedRole.name }}（{{ selectedRole.staffCount }}人）
            </span>
          </div>
          <div>
            <el-button @click="showEditDrawer" plain style="width:102px">
              编辑职位
            </el-button>
            <el-button @click="changeToPermissionMode" type="primary" style="width:102px">
              权限设置
            </el-button>
          </div>
        </div>
        <div class="note-box">
          <span class="label">备注：</span>
          <span>{{ selectedRole.note || '-' }}</span>
        </div>
        <div class="divider my-25"></div>
        <div class="staff-block">
          <div class="header">
            <span class="title">职员列表</span>
            <div style="display:flex">
              <el-button @click="showStaffDialog" plain class="create-btn">
                <i class="mdg-icon ico_creatx text-primary vcenter"></i>
                <span class="vcenter">添加</span>
              </el-button>
              <el-button @click="removeStaffs" type="danger" plain class="create-btn mr-15">
                <i class="mdg-icon ico_delect_redx text-danger vcenter"></i>
                <span class="vcenter">移除</span>
              </el-button>
              <div style="display:flex">
                <el-input
                  v-model="staffKeyword" placeholder="搜索手机号/姓名/账号名"
                  @keyup.enter.native="searchStaffs" style="width:264px"
                ></el-input>
                <el-button @click="searchStaffs" type="primary" class="search-btn">
                  <i class="mdg-icon ico_searchx text-white" alt="搜索" />
                </el-button>
              </div>
            </div>
          </div>
          <el-table
            :data="selectedRole.shownStaffs" stripe :max-height="650"
            class="staff-table" @selection-change="selectionChange"
          >
            <el-table-column width="60" align="center" type="selection"></el-table-column>
            <el-table-column
              align="left" show-overflow-tooltip
              prop="index" label="序号" :width="60"
            >
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column
              v-for="column in columns" :key="column.key"
              align="left" show-overflow-tooltip :width="column.width"
              :prop="column.key" :label="column.label"
            ></el-table-column>
          </el-table>
        </div>
      </div>
      <div v-if="mode === 'create'">
        <div class="breadcrumb">
          <span>职位权限管理</span>
          <i class="mdg-icon ico_arrow_right_grayx"></i>
          <span>新增职位</span>
        </div>
        <div class="card">
          <div class="card-header">
            <div class="title">新增职位</div>
            <el-button @click="createRole" type="primary" style="width:88px">
              保存
            </el-button>
          </div>
          <div>
            <div class="form-group-title">职位信息</div>
            <el-form
              :model="createForm" :rules="createFormRules"
              ref="createForm" label-width="82px" class="mdg-form"
            >
              <el-form-item label="职位名称" prop="name">
                <el-input
                  v-model.trim="createForm.name" placeholder="请输入职位名称" style="width:400px"
                ></el-input>
              </el-form-item>
              <el-form-item label="备注" prop="note">
                <el-input
                  v-model="createForm.note" type="textarea" :rows="3"
                  placeholder="请输入备注" resize="none" style="width:400px"
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="divider my-30"></div>
          <div>
            <div class="form-group-title">权限赋予</div>
            <div
              v-if="permissionGroups.length <= 0"
              class="permission-group-container pl-15"
            >
              暂无权限
            </div>
            <div v-else class="permission-group-container">
              <div v-for="(group, i) in permissionGroups" :key="i" class="permission-group">
                <div class="name">{{ group.name }}</div>
                <div class="permission-list">
                  <div
                    v-for="permission in group.children"
                    :key="permission[0].id" class="inline-block"
                  >
                    <div class="permission-tree-wrapper">
                      <img :src="permission[0].logo" class="logo" alt="" />
                      <el-tree
                        :data="permission" ref="createPermissionTree"
                        node-key="id" default-expand-all show-checkbox
                        class="permission-tree" empty-text="暂无数据"
                      >
                        <div slot-scope="{data}" class="tree-node">
                          <span class="node-name vcenter">{{ data.name }}</span>
                        </div>
                      </el-tree>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="mode === 'permission'">
        <div class="breadcrumb">
          <span @click="changeSelectedRole(selectedRole)" class="cursor-pointer">
            {{ selectedRole.name }}
          </span>
          <i class="mdg-icon ico_arrow_right_grayx"></i>
          <span>权限设置</span>
        </div>
        <div class="card">
          <div class="card-header">
            <div class="title">权限设置</div>
          </div>
          <div class="form-group-title">权限赋予</div>
          <div
            v-if="permissionGroups.length <= 0"
            class="permission-group-container pl-15"
          >
            暂无权限
          </div>
          <div v-else class="permission-group-container">
            <div v-for="(group, i) in permissionGroups" :key="i" class="permission-group">
              <div class="name">{{ group.name }}</div>
              <div class="permission-list">
                <div
                  v-for="(permission, j) in group.children"
                  :key="permission[0].id" class="inline-block"
                >
                  <div class="permission-tree-wrapper">
                    <img :src="permission[0].logo" class="logo" alt="" />
                    <el-tree
                      :data="permission" ref="settingsPermissionTree"
                      node-key="id" default-expand-all show-checkbox
                      class="permission-tree" empty-text="暂无数据"
                      :check-strictly='is_check_strictly'
                      @check="permissionTreeCheckChange(i, j, ...arguments)"
                    >
                      <div slot-scope="{data}" class="tree-node">
                        <span class="node-name vcenter">{{ data.name }}</span>
                      </div>
                    </el-tree>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <drawer :show.sync="editDrawerShown" pos="right" :close-on-click-mask="false" >
      <div class="drawer-container">
        <div class="header">编辑职位</div>
        <div class="py-30 pl-20 pr-55 mt-60">
          <el-form
            :model="editForm" :rules="editFormRules"
            ref="editForm" label-width="80px" class="mdg-form"
          >
            <el-form-item label="职位名称" prop="name">
              <el-input v-model.trim="editForm.name" placeholder="请输入职位名称"></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="note">
              <el-input
                v-model="editForm.note" type="textarea" :rows="3"
                placeholder="请输入备注" resize="none"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="footer">
          <el-button @click="closeEditDrawer" type="default" size="small">取消</el-button>
          <el-button @click="removeRole" class="remove-btn" plain type="danger" size="small">
            删除
          </el-button>
          <el-button @click="submitEditDrawer" type="primary" size="small">保存</el-button>
        </div>
      </div>
    </drawer>
    <el-dialog
      :visible.sync="staffDialog.shown" title="添加职员"
      width="800px" :close-on-click-modal="false"
    >
      <div class="dialog-body">
        <div style="display:flex; float:right;" class="mb-15">
          <el-input
            v-model="staffDialog.keyword" placeholder="搜索手机号/姓名/账号名"
            @keyup.enter.native="dialogSearchStaffs" style="width:264px"
          ></el-input>
          <el-button @click="dialogSearchStaffs" type="primary" class="search-btn">
            <i class="mdg-icon ico_searchx text-white" alt="搜索" />
          </el-button>
        </div>
        <el-table
          :data="staffDialog.staffs" stripe :max-height="550"
          @selection-change="dialogSelectionChange" class="staff-table"
        >
          <el-table-column width="60" align="center" type="selection"></el-table-column>
          <el-table-column
            v-for="column in staffDialog.columns" :key="column.key"
            align="left" show-overflow-tooltip :width="column.width"
            :prop="column.key" :label="column.label"
          ></el-table-column>
        </el-table>
        <div class="text-right mt-15">
          <el-pagination
            class="px-0" background
            layout="prev, pager, next, sizes"
            @current-change="dialogOnPageChange"
            @size-change="dialogOnPageSizeChange"
            :current-page="staffDialog.query.page"
            :page-size="staffDialog.query.pageSize"
            :page-sizes="[10, 20, 50, 70, 100, 150, 200, 300, 500]"
            :total="staffDialog.query.total"
          ></el-pagination>
        </div>
      </div>
      <div class="dialog-footer">
        <el-button @click="submitStaffDialog" type="primary" size="small" class="action-btn">
          确定
        </el-button>
        <el-button @click="closeStaffDialog" type="default" size="small" class="action-btn">
          取消
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import {
  Input, Button, Table, TableColumn,
  Form, FormItem, Dialog, Pagination,
  Tree,
} from 'element-ui'
import Drawer from '@/components/Drawer'
import * as API from '@/api/role'
import Sortable from 'sortablejs';

const PAGE_SIZE = 10

export default {
  name: 'role-view',
  components: {
    ElInput: Input,
    ElButton: Button,
    ElTable: Table,
    ElTableColumn: TableColumn,
    ElForm: Form,
    ElFormItem: FormItem,
    ElDialog: Dialog,
    ElPagination: Pagination,
    ElTree: Tree,
    Drawer,
  },
  data() {
    return {
      mode: 'view',
      keyword: '',
      roles: [],
      shownRoles: [],
      selectedRole: {
        id: -1,
        name: '',
        note: '',
        staffCount: 0,
        staffs: [],
        shownStaffs: [],
      },
      permissionGroups: [],
      groupSelectedPermissions: [],
      createForm: {
        name: '',
        note: '',
        permissions: [],
      },
      createFormRules: {
        name: [{ required: true, message: '请填写职位名称' }],
      },
      staffKeyword: '',
      selectedStaffs: [],
      columns: [{
        key: 'username',
        label: '账号名',
      }, {
        key: 'name',
        label: '姓名',
      }, {
        key: 'mobilePhone',
        label: '手机号码',
      }, {
        key: 'departments',
        label: '部门',
      }],
      editForm: {
        name: '',
        note: '',
      },
      editFormRules: {
        name: [{ required: true, message: '请填写职位名称' }],
      },
      editDrawerShown: false,
      staffDialog: {
        shown: false,
        keyword: '',
        staffs: [],
        selected: [],
        query: {
          id: -1,
          page: 1,
          pageSize: PAGE_SIZE,
          total: 0,
          totalPages: 1,
          keyword: '',
        },
        columns: [{
          key: 'index',
          label: '序号',
          width: 60,
        }, {
          key: 'username',
          label: '账号名',
        }, {
          key: 'name',
          label: '姓名',
        }, {
          key: 'mobilePhone',
          label: '手机号码',
        }],
      },
      is_check_strictly: true,
    }
  },
  async mounted() {
    document.body.style.overflow = 'hidden'
    await this.initData()
    this.initSortable()
  },
  beforeDestroy() {
    document.body.style.overflow = 'auto'
  },
  methods: {
    async initData(role, keyword = '', staffKeyword = '') {
      this.keyword = keyword
      this.selectedRole = {
        id: -1,
        name: '',
        note: '',
        staffCount: 0,
        staffs: [],
        shownStaffs: [],
      }
      const loading = this.$loading({
        lock: true,
        text: '加载中...',
      })
      this.roles = await API.find()
      this.searchRoles()
      loading.close()

      if (this.roles.length <= 0) {
        return
      }

      await this.changeSelectedRole(role || this.roles[0], staffKeyword)
    },
    initSortable () {
      let that = this
      this.$nextTick(() => {
        const el = document.getElementById('role-list')
        Sortable.create(el, {
          onEnd: async (evt) => {
            console.log(evt)
            const form = {
              id: that.shownRoles[evt.oldIndex].id,
              target_id: that.shownRoles[evt.newIndex].id,
              move_type: 1,
            }
            console.log(form)
            await API.sortPosition(form)
          },
        })
      })
    },
    searchRoles() {
      this.shownRoles = this.roles.filter(
        item => item.name.indexOf(this.keyword) >= 0,
      )
    },
    async changeSelectedRole(role, staffKeyword) {
      const loading = this.$loading({
        lock: true,
        text: '加载中...',
      })
      const result = await API.get({ id: role.id })
      loading.close()
      if (result) {
        this.selectedRole = result
        this.staffKeyword = staffKeyword || ''
        this.searchStaffs()
        this.mode = 'view'
      }
    },
    createRole() {
      this.$refs.createForm.validate(async (valid) => {
        if (!valid) {
          return
        }
        try {
          await this.$confirm('确定要添加职位吗？', '提示', {
            type: 'warning',
            confirmButtonText: '确定',
            cancelButtonText: '取消',
          })
          const loading = this.$loading({
            lock: true,
            text: '加载中...',
          })
          const permissions = !_.isEmpty(this.$refs.createPermissionTree)
            ? this.$refs.createPermissionTree.map((tree) => {
              let keys = tree.getCheckedKeys()
              keys = keys.concat(tree.getHalfCheckedKeys())
              return keys
            }).reduce((arr, current) => arr.concat(current), [])
            : []
          const id = await API.create({
            name: this.createForm.name,
            note: this.createForm.note,
            permissions,
          })
          loading.close()
          if (_.isNumber(id) && id > 0) {
            this.$message({
              type: 'success',
              message: '添加成功',
            })
            await this.initData({ id })
          }
        } catch (e) {
          // noop
        }
      })
    },
    async changeToCreateMode() {
      if (this.mode === 'create') {
        return
      }
      this.createForm = {
        name: '',
        note: '',
        permissions: [],
      }
      this.mode = 'create'

      if (_.isEmpty(this.permissionGroups)) {
        const loading = this.$loading({
          lock: true,
          text: '加载中...',
        })
        this.permissionGroups = await API.findAllPermissionGroups()
        loading.close()
      }

      this.$nextTick(() => {
        this.$refs.createForm.clearValidate()
      })
    },
    showEditDrawer() {
      this.editForm = {
        name: this.selectedRole.name,
        note: this.selectedRole.note,
      }
      this.editDrawerShown = true
      this.$nextTick(() => {
        this.$refs.editForm.clearValidate()
      })
    },
    closeEditDrawer() {
      this.editDrawerShown = false
    },
    submitEditDrawer() {
      this.$refs.editForm.validate(async (valid) => {
        if (!valid) {
          return
        }
        try {
          await this.$confirm('确定要编辑职位吗？', '提示', {
            type: 'warning',
            confirmButtonText: '确定',
            cancelButtonText: '取消',
          })
          const loading = this.$loading({
            lock: true,
            text: '加载中...',
          })
          const flag = await API.update({
            id: this.selectedRole.id,
            name: this.editForm.name,
            note: this.editForm.note,
          })
          loading.close()
          if (flag) {
            this.$message({
              type: 'success',
              message: '编辑成功',
            })
            this.editDrawerShown = false

            await this.initData(this.selectedRole, this.keyword, this.staffKeyword)
          }
        } catch (e) {
          // noop
        }
      })
    },
    async changeToPermissionMode() {
      this.mode = 'permission'
      this.is_check_strictly = true // 每次进来渲染的时候都要设置为不关联模式
      if (_.isEmpty(this.permissionGroups)) {
        const loading = this.$loading({
          lock: true,
          text: '加载中...',
        })
        this.permissionGroups = await API.findAllPermissionGroups()
        loading.close()
      }

      const loading = this.$loading({
        lock: true,
        text: '加载中...',
      })
      const results = await API.findRolePermissions({
        id: this.selectedRole.id,
      })
      loading.close()
      if (_.isEmpty(this.permissionGroups)) {
        return
      }
      console.log(results, '所有权限值')
      new Promise((resolve) => { //
        this.$refs.settingsPermissionTree.forEach((tree) => {
          // tree.setCheckedKeys([])
          tree.setCheckedKeys(results, false)
        })
        resolve()
      }).then(() => {
        this.is_check_strictly = false // 将所有组件树初始时候设置为断开父子关系，渲染完成后再设置连接父子关系 2020-01-20
      }).then(() => {
        // 记录修改前的权限选中状态
        this.groupSelectedPermissions = this.$refs.settingsPermissionTree.map(tree => ({
          checkedKeys: tree.getCheckedKeys(),
          halfCheckedKeys: tree.getHalfCheckedKeys(),
        }))
      })
    },
    async permissionTreeCheckChange(i, j, data, { checkedKeys, halfCheckedKeys }) {
      console.log(i, j, data, { checkedKeys, halfCheckedKeys })
      const index = _.range(i).reduce(
        (total, current) => total + this.permissionGroups[current].children.length, 0,
      ) + j
      const old = this.groupSelectedPermissions[index]
      const oldKeys = old.checkedKeys.concat(old.halfCheckedKeys)
      const newKeys = checkedKeys.concat(halfCheckedKeys)

      const loading = this.$loading({
        lock: true,
        text: '加载中...',
      })
      const flag = await API.changePermissions({
        id: this.selectedRole.id,
        permissions: _.xor(oldKeys, newKeys),
        add: newKeys.length > oldKeys.length,
      })
      loading.close()
      if (flag) {
        this.groupSelectedPermissions[index] = {
          checkedKeys: _.clone(checkedKeys),
          halfCheckedKeys: _.clone(halfCheckedKeys),
        }
        this.$message({
          type: 'success',
          message: '设置成功',
        })
      } else {
        // 修改失败，恢复到原来的状态
        const tree = this.$refs.settingsPermissionTree[index]
        tree.getCheckedKeys().forEach(id => tree.setChecked(id, false, true))
        tree.setCheckedKeys(old.checkedKeys)
      }
    },
    async removeRole() {
      try {
        await this.$confirm('确定要删除该职位吗？', '提示', {
          type: 'warning',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        })
        const loading = this.$loading({
          lock: true,
          text: '加载中...',
        })
        const flag = await API.remove({
          id: this.selectedRole.id,
        })
        loading.close()
        if (flag) {
          this.$message({
            type: 'success',
            message: '删除成功',
          })
          this.editDrawerShown = false

          await this.initData()
        }
      } catch (e) {
        // noop
      }
    },
    async showStaffDialog() {
      this.staffDialog.keyword = ''
      this.staffDialog.query = {
        id: this.selectedRole.id,
        page: 1,
        pageSize: PAGE_SIZE,
        total: 0,
        totalPages: 1,
        keyword: '',
      }
      this.staffDialog.shown = true
      await this.dialogFindStaffs()
    },
    async submitStaffDialog() {
      if (_.isEmpty(this.staffDialog.selected)) {
        this.$message({
          type: 'error',
          message: '没有选中任何职员',
        })
        return
      }

      try {
        await this.$confirm('确定要将这些职员添加到该职位吗？', '提示', {
          type: 'warning',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        })
        const loading = this.$loading({
          lock: true,
          text: '加载中...',
        })
        const flag = await API.addStaffs({
          roleId: this.selectedRole.id,
          userIds: this.staffDialog.selected.map(item => item.id),
        })
        loading.close()
        if (flag) {
          this.$message({
            type: 'success',
            message: '添加成功',
          })
          this.staffDialog.shown = false

          await this.changeSelectedRole(this.selectedRole)
        }
      } catch (e) {
        // noop
      }
    },
    closeStaffDialog() {
      this.staffDialog.shown = false
    },
    async dialogFindStaffs() {
      const loading = this.$loading({
        lock: true,
        text: '加载中...',
      })
      const data = await API.findExternalStaffs(this.staffDialog.query)
      loading.close()
      this.query = Object.assign(this.staffDialog.query, _.pick(data, [
        'page', 'pageSize', 'total', 'totalPages',
      ]))
      this.staffDialog.staffs = data.results
    },
    dialogSelectionChange(selection) {
      this.staffDialog.selected = _.intersectionWith(this.staffDialog.staffs, selection, (a, b) => {
        let flag = true
        const keys = Object.keys(b)
        for (let i = 0; i < keys.length; i += 1) {
          const key = keys[i]
          if (b[key] !== a[key]) {
            flag = false
            break
          }
        }
        return flag
      })
    },
    async dialogSearchStaffs() {
      this.staffDialog.query.keyword = this.staffDialog.keyword || ''
      this.staffDialog.query.page = 1
      await this.dialogFindStaffs()
    },
    async dialogOnPageChange(page) {
      this.staffDialog.query.page = page
      await this.dialogFindStaffs()
    },
    async dialogOnPageSizeChange(pageSize) {
      this.staffDialog.query.page = 1
      this.staffDialog.query.pageSize = pageSize
      await this.dialogFindStaffs()
    },
    async removeStaffs() {
      if (_.isEmpty(this.selectedStaffs)) {
        this.$message({
          type: 'error',
          message: '没有选中任何职员',
        })
        return
      }

      try {
        await this.$confirm('确定要将这些职员移出该职位吗？', '提示', {
          type: 'warning',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        })
        const loading = this.$loading({
          lock: true,
          text: '加载中...',
        })
        const flag = await API.removeStaffs({
          roleId: this.selectedRole.id,
          userIds: this.selectedStaffs.map(item => item.id),
        })
        loading.close()
        if (flag) {
          this.$message({
            type: 'success',
            message: '删除成功',
          })

          await this.changeSelectedRole(this.selectedRole, this.staffKeyword)
        }
      } catch (e) {
        // noop
      }
    },
    searchStaffs() {
      this.selectedRole.shownStaffs = this.selectedRole.staffs.filter(item => (
        item.mobilePhone.indexOf(this.staffKeyword) >= 0
        || item.name.indexOf(this.staffKeyword) >= 0
        || item.username.indexOf(this.staffKeyword) >= 0
      ))
    },
    selectionChange(selection) {
      this.selectedStaffs = _.intersectionWith(this.selectedRole.shownStaffs, selection, (a, b) => {
        let flag = true
        const keys = Object.keys(b)
        for (let i = 0; i < keys.length; i += 1) {
          const key = keys[i]
          if (b[key] !== a[key]) {
            flag = false
            break
          }
        }
        return flag
      })
    },
  },

}
</script>

<style lang="scss" scoped>
@import 'src/styles/variable.scss';

.sidebar {
  box-sizing: border-box;
  position: fixed;
  top: 84px;
  left: 0;
  padding: 20px;
  width: 358px;
  height: calc(100vh - 84px);
  background: #f5f7f9;
  border-radius: 2px 0px 0px 2px;
  box-shadow: 0px 0px 10px 0px rgba(53,129,251,0.1);
  overflow: auto;
}
.main-content {
  box-sizing: border-box;
  position: fixed;
  top: 84px;
  left: 358px;
  padding: 20px;
  width: calc(100vw - 358px);
  height: calc(100vh - 84px);
  overflow: auto;
}
.card {
  box-sizing: border-box;
  padding: 20px;
  width: 100%;
  min-width: 700px;
  min-height: 100%;
  background: #fff;
  box-shadow: 0px 0px 10px 0px rgba(53,129,251,0.1);
  border-radius: 2px;
  .card-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 28px;
    .title {
      display: inline-block;
      vertical-align: text-bottom;
      color: #131d2d;
      font-size: 20px;
      line-height: 28px;
      font-weight: bold;
    }
    .title-icon {
      color: #131d2d;
      font-size: 32px;
      margin-right: 8px;
    }
  }
  .note-box {
    margin-top: 23px;
    line-height: 20px;
    .label {
      color: #6f83a1;
      font-weight: bold;
    }
  }
}
.create-btn {
  padding: 0 12px !important;
  i.mdg-icon {
    margin-right: 6px;
    font-size: 24px;
  }
}
.role-item {
  padding: 8px 12px;
  color: #131d2d;
  line-height: 20px;
  cursor: pointer;
  .mdg-icon {
    margin-right: 3px;
    font-size: 20px;
    color: #a3b4cc;
  }
  &:hover {
    background-color: darken(#f5f7fa, 4%);
  }
  &.selected {
    background-color: $primary;
    color: #fff;
  }
}
.divider {
  width: 100%;
  height: 1px;
  background: #d3d9e2;
}
.staff-block {
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 18px;
    .title {
      font-size: 18px;
      font-weight: bold;
      color: #131d2d;
      line-height: 25px;
    }
  }
}
.search-btn {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius:0 !important;
  padding: 0 !important;
  width: 36px;
  height: 36px;
  line-height: 32px;
  text-align: center;
  margin-left: -2px;
  z-index: 100;
  i.mdg-icon {
    font-size: 20px;
  }
}
.drawer-container {
  box-sizing: border-box;
  position: relative;
  padding-bottom: 57px;
  width: 560px;
  height: 100%;
  overflow: auto;
  .header {
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    padding: 0 24px;
    color: #131d2d;
    font-size: 16px;
    font-weight: bold;
    line-height: 60px;
    background: #f5f7f9;
  }
  .footer {
    z-index: 10;
    box-sizing: border-box;
    position: fixed;
    bottom: 0;
    left: 0;
    padding: 0 24px;
    width: 100%;
    text-align: right;
    line-height: 57px;
    background: #f8f9fA;
  }
}
.remove-btn {
  color: $danger !important;
  border-color: $danger !important;
  &:hover {
    background-color: lighten($danger, 30%) !important;
  }
  &:active {
    background-color: lighten($danger, 25%) !important;
  }
}
.dialog-body {
  padding: 20px 32px;
}
.dialog-footer {
  padding: 20px 0 40px;
  text-align: center;
  .action-btn {
    width: 106px;
    &:not(:first-child) {
      margin-left: 12px;
    }
  }
}
.breadcrumb {
  margin-bottom: 18px;
  font-size: 18px;
  line-height: 25px;
  font-weight: bold;
  color: #a3b4cc;
  .mdg-icon {
    margin: 0 2px;
    display: inline-block;
    vertical-align: middle;
    font-size: 20px;
  }
  span:last-child {
    color: #131d2d;
  }
}
.form-group-title {
  position: relative;
  margin-bottom: 20px;
  padding-left: 14px;
  font-weight: bold;
  color: #131d2d;
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 4px;
    height: 16px;
    background: $primary;
  }
}
.permission-group-container {
  margin-top: 15px;
  font-size: 14px;
}
.permission-group {
  margin-bottom: 15px;
  padding: 15px 10px 15px 20px;
  background: darken(#f5f7f9, 5%);
  border-radius: 2px;
  &:last-child {
    margin-bottom: 0;
  }
  .name {
    font-size: 18px;
    color: #333;
    font-weight: bold;
    line-height: 24px;
  }
}
.permission-list {
  margin-left: -10px;
  .note {
    margin-bottom: 10px;
    padding: 0 10px;
  }
}
.permission-tree-wrapper {
  display: flex;
  box-sizing: border-box;
  margin: 10px;
  padding: 16px;
  width: 320px;
  height: 180px;
  background: #f5f7f9;
  overflow: auto;
  .logo {
    width: 48px;
    height: 48px;
    border-radius: 2px;
    overflow: hidden;
  }
}
.permission-tree {
  flex: 1;
  height: 148px;
  background: transparent;
  overflow: auto;
}
</style>

<style lang="scss">
.search-box {
  .el-input__inner {
    padding-right: 35px !important;
    &:focus {
      border-color: #6f83a1 !important;
    }
  }
  .mdg-icon {
    margin: 0 5px;
    font-size: 20px;
    line-height: 36px;
    cursor: pointer;
  }
}
.permission-tree>.el-tree-node>.el-tree-node__content:first-child {
  .tree-node {
    margin-top: -2px;
    font-size: 16px;
    color: #333;
    font-weight: bold;
    line-height: 22px;
  }
}
</style>
